import { ProjectIssueFragment } from "@/generated/graphql";

/**
 * Extends the Project Issue type from GQL to have children field
 * as it originally does not (and does not need to). This is only
 * for the UI side of things.
 */
export interface ProjectIssueWithChildren extends ProjectIssueFragment {
  children: ProjectIssueWithChildren[];
}

/** Prjoect Issue Column IDs  */
export enum ColumnId {
  Id = "Id",
  Select = "Select",
  Title = "Title",
  Description = "Description",
  Assignee = "Assignee",
  DueDate = "DueDate",
  Status = "Status",
  Actions = "Actions",
  Expand = "Expand",
}

export type DateRange = [Date | null, Date | null];
